import { memo } from "react";

// Reduced from 39 → 16 nodes, spread evenly across viewport
const nodes = [
  {x:120,y:100}, {x:400,y:60}, {x:720,y:130}, {x:1050,y:70}, {x:1320,y:140},
  {x:200,y:280}, {x:560,y:250}, {x:840,y:310}, {x:1140,y:260},
  {x:100,y:430}, {x:440,y:400}, {x:700,y:460}, {x:1000,y:420}, {x:1300,y:450},
  {x:300,y:560}, {x:900,y:550},
];
const colors = ["#8B5CF6", "#EC4899", "#3B82F6"];

// Reduced connection distance → fewer lines. Static opacity, no animation on lines.
const connections = [];
for (let i = 0; i < nodes.length; i++) {
  for (let j = i + 1; j < nodes.length; j++) {
    const dx = nodes[i].x - nodes[j].x, dy = nodes[i].y - nodes[j].y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist < 320) {
      connections.push([i, j, dist < 180 ? 0.2 : 0.08]);
    }
  }
}

// Only 4 shooting stars (down from 58)
const shootingStars = [
  { x1: 50, y1: 120, x2: 550, y2: 350, d: 12 },
  { x1: 600, y1: 40, x2: 1100, y2: 280, d: 15 },
  { x1: 900, y1: 100, x2: 1400, y2: 400, d: 13 },
  { x1: 200, y1: 400, x2: 750, y2: 600, d: 14 },
];

export const NeuralBackground = memo(() => {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  if (isMobile) return null;

  return (
    <div
      className="fixed inset-0 pointer-events-none z-0 hidden md:block"
      style={{ opacity: 0.4, willChange: "auto", contain: "strict" }}
    >
      <svg className="w-full h-full" viewBox="0 0 1440 700" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="nb-lg" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#8B5CF6" />
            <stop offset="50%" stopColor="#EC4899" />
            <stop offset="100%" stopColor="#3B82F6" />
          </linearGradient>
          <radialGradient id="nb-sg">
            <stop offset="0%" stopColor="#fff" stopOpacity="1" />
            <stop offset="30%" stopColor="#EC4899" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Static connection lines — no animation, just opacity */}
        {connections.map(([a, b, op], i) => (
          <line
            key={i}
            x1={nodes[a].x} y1={nodes[a].y}
            x2={nodes[b].x} y2={nodes[b].y}
            stroke="url(#nb-lg)" strokeWidth="0.6" opacity={op}
          />
        ))}

        {/* Nodes — single circle with gentle pulse */}
        {nodes.map((n, i) => (
          <circle
            key={i}
            cx={n.x} cy={n.y} r="2.5"
            fill={colors[i % 3]}
            opacity="0.5"
            style={{
              animation: `nb-pulse ${3 + (i % 2)}s ease-in-out infinite`,
              animationDelay: `${(i * 0.6) % 4}s`,
              willChange: "opacity",
            }}
          />
        ))}

        {/* 4 shooting stars */}
        {shootingStars.map((s, i) => (
          <circle
            key={`ss${i}`}
            r="3"
            fill="url(#nb-sg)"
            style={{
              offsetPath: `path("M${s.x1},${s.y1} L${s.x2},${s.y2}")`,
              animation: `nb-shoot ${s.d}s ease-in-out infinite`,
              animationDelay: `${i * 3.5}s`,
              willChange: "offset-distance, opacity",
            }}
          />
        ))}
      </svg>
    </div>
  );
});

NeuralBackground.displayName = "NeuralBackground";
export default NeuralBackground;
